var React = require('react');

function LongArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("polygon",{"points":"25.37 7.67 24.63 8.33 31.86 16.47 1 16.47 1 17.53 31.86 17.53 24.63 25.67 25.37 26.33 33.67 17 25.37 7.67","key":1})]);
}

LongArrow.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = LongArrow;

LongArrow.default = LongArrow;
